import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ModifiersEnum} from '../../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import {ViewerPanelConversationPageState} from '../../../../../store/panels/viewer/viewerPanelState';
import {Highlighter} from '../../../../common/highlighter';
import {HighlightsCoordinatorProvider} from '../../../../common/highlighter/highlightsCoordinator';
import {ConversationSearchContextProvider} from './conversationSearchContext';

/*
 * Constants.
 */

const acceptedModifiersForHighlight = [
  ModifiersEnum.RECIPIENT,
  ModifiersEnum.FROM,
  ModifiersEnum.TO,
  ModifiersEnum.CC,
  ModifiersEnum.BCC,
  ModifiersEnum.SUBJECT,
  ModifiersEnum.BODY,
];

/*
 * Props.
 */

interface ConversationHighlightsProps {
  /**
   * Query from the P0 search bar.
   */
  globalQuery: string | undefined;

  panelId: ViewerPanelId;
  page: ViewerPanelConversationPageState;
}

/*
 * Style.
 */

const StyledGlobalHighlighter = styled(Highlighter)`
  background-color: ${(p) => p.theme.palette.yellow.highlight};
  color: ${(p) => p.theme.highlightText};
`;

/*
 * Component.
 */

export const ConversationHighlights: FC<PropsWithChildren<ConversationHighlightsProps>> = (props) => {
  const {globalQuery = '', panelId, page, children} = props;

  return (
    <HighlightsCoordinatorProvider>
      <ConversationSearchContextProvider panelId={panelId} page={page}>
        {globalQuery && (
          <StyledGlobalHighlighter
            id="p0-search"
            query={globalQuery}
            acceptedModifiers={acceptedModifiersForHighlight}
          />
        )}
        {children}
      </ConversationSearchContextProvider>
    </HighlightsCoordinatorProvider>
  );
};
